module.exports = __webpack_public_path__ + "img/massage.6db4a086.jpeg";